
<template>
  <v-sheet height="500px" class="d-flex justify-center align-center">
    <v-card flat class="mt-5">
      <v-card-text class="pa-0">
        <v-row class="pa-0">
          <v-col cols="12" class="pa-0">
            <div class="d-flex flex-column justify-center align-center">
              <v-icon size="200px" color="success">mdi-check-circle</v-icon>
              <span class="title font-weight-medium"> Pedido criado com sucesso! </span>
            </div>
          </v-col>
          <v-col cols="12" class="pa-0">
            <div>
              <v-btn @click="goToOrder" block color="primary" class="mt-10" dark> 
                <v-icon left>mdi-open-in-new</v-icon>Acessar pedido
              </v-btn>
              <v-btn @click="goToNewOrder" block color="#E53935" class="mt-3" dark> 
                <v-icon left>mdi-plus</v-icon>Novo pedido
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import cimentao_links from "@/mixins/cimentao_links";

export default {
  name: 'OrderFinished',
  mixins: [ cimentao_links ],
  props:{
    done_order:{
      type: Object
    }
  },
  methods: {
    goToOrder(){
      if(this.done_order?.solution == 'retail'){
        this.goToRetailPage(this.done_order?.id)
      }else{
        this.goToWholesalePage(this.done_order?.id)
      }
    },
    goToNewOrder(){
      // this.$emit('newOrder')
      this.$router.go()
    },
  },
}
</script>